import type { NetztransparenzMissingValue } from "../NetztransparenzValuesError";

function groupMissingValues(
  missingValues: NetztransparenzMissingValue[]
): NetztransparenzMissingValue[] {
  return Object.values(
    missingValues.reduce(
      (acc, item) => {
        const existing = acc[item.label] || {
          label: item.label,
          periods: []
        };
        acc[item.label] = {
          label: item.label,
          periods: [...existing.periods, ...(item.periods || [])]
        };
        return acc;
      },
      {} as Record<string, NetztransparenzMissingValue>
    )
  );
}
export { groupMissingValues };
